import React from 'react'
import {
  StyledEquipmentMethod,
  StyledEquipmentPanel,
  StyledInfoContainer,
  StyledInfoIcon,
} from './AddEquipment.styled'
import AddEquipmentLevelSlider from './AddEquipmentLevelSlider/AddEquipmentLevelSlider'
import RadioGroupButtons from 'components/RadioGroupButtons/RadioGroupButtons'
import { useSelector } from 'react-redux'
import { EquipmentMethod } from 'types/EquipmentMethod'
import { useTranslation } from 'react-i18next'
import { useAppDispatch } from 'store/hooks'
import { selectAddressFormData, setFormField } from 'slices/addressFormSlice'
import { StyledLine } from '../MapOrReport/MapOrReportObjectDataForm/MapOrReportObjectDataForm.styled'
import MapOrReportEquipmentMatrixForm from '../MapOrReport/MapOrReportEquipmentMatrixForm/MapOrReportEquipmentMatrixForm'
import { ReactComponent as InfoIcon } from 'assets/images/icons/info.svg'
import ValueEquipmentMatrixForm from '../Value/ValueEquipmentMatrixForm/ValueEquipmentMatrixForm'

const equipmentMethods = [
  {
    key: EquipmentMethod.SIMPLE,
    value: 'newAddressModal.furnishingTab.equipmentMethod.simple',
  },
  {
    key: EquipmentMethod.DETAILED,
    value: 'newAddressModal.furnishingTab.equipmentMethod.detailed',
  },
  {
    key: EquipmentMethod.AUTOMATIC,
    value: 'newAddressModal.furnishingTab.equipmentMethod.automatic',
  },
]

function AddEquipment(props: any) {
  const { setShowValidation, setValidationErrors } = props
  const dispatch = useAppDispatch()
  const { t } = useTranslation()
  const addressFormData = useSelector(selectAddressFormData)
  const isMapOrReport =
    addressFormData.productName === 'report' || addressFormData.productName === 'map'
  const isValue = addressFormData.productName === 'value'

  const handleChangeEquipmentMethodChange = (value) => {
    dispatch(setFormField({ key: 'propertyDetails.equipmentMethod', value }))
    if (setShowValidation) {
      setShowValidation(false)
    }
    if (setValidationErrors) {
      setValidationErrors([])
    }
  }

  if (addressFormData.addressData?.propertyDetails?.equipmentMethod === undefined) {
    dispatch(
      setFormField({ key: 'propertyDetails.equipmentMethod', value: EquipmentMethod.SIMPLE })
    )
  }

  return (
    <>
      <StyledEquipmentPanel>
        <StyledEquipmentMethod>
          <RadioGroupButtons
            options={equipmentMethods}
            label={t('newAddressModal.furnishingTab.equipmentMethod.label')}
            onChange={(event) => handleChangeEquipmentMethodChange(event.target.value)}
            value={
              addressFormData.addressData?.propertyDetails?.equipmentMethod ||
              EquipmentMethod.SIMPLE
            }
          />
        </StyledEquipmentMethod>
        <StyledLine />
        {addressFormData.addressData?.propertyDetails?.equipmentMethod ===
          EquipmentMethod.SIMPLE && <AddEquipmentLevelSlider />}
        {addressFormData.addressData?.propertyDetails?.equipmentMethod ===
          EquipmentMethod.DETAILED &&
          isMapOrReport && <MapOrReportEquipmentMatrixForm />}
        {addressFormData.addressData?.propertyDetails?.equipmentMethod ===
          EquipmentMethod.DETAILED &&
          isValue && <ValueEquipmentMatrixForm {...props} />}
        {addressFormData.addressData?.propertyDetails?.equipmentMethod ===
          EquipmentMethod.AUTOMATIC && (
          <StyledInfoContainer>
            <StyledInfoIcon>
              <InfoIcon />
            </StyledInfoIcon>
            <span>{t('newAddressModal.furnishingTab.equipmentMethod.automatic.description')}</span>
          </StyledInfoContainer>
        )}
      </StyledEquipmentPanel>
    </>
  )
}

export default AddEquipment
